class MiniModal {
	static CLASS_NAME_ACTIVE = 'jtf__minimodal--modal--active'
	static SELECTOR_CLASS_MINIMODAL = '.jtf__minimodal'
	static SELECTOR_CLASS_TRIGGER = '.jtf__minimodal--modal--trigger--button'
	static SELECTOR_CLASS_CLOSE = '.jtf__minimodal--modal--close--button'
	static SELECTOR_CLASS_CONTENT = '.jtf__minimodal--modal--content'
	static KEYCODE_ESCAPE = 'Escape'
	static KEYCODE_TAB = 'Tab'
	static ATTR_TABINDEX = 'tabindex'

	constructor( context ) {
		this.context = context
		this.trigger = context.querySelector( MiniModal.SELECTOR_CLASS_TRIGGER )
		this.close = context.querySelector( MiniModal.SELECTOR_CLASS_CLOSE )
		this.modalContent = context.querySelector( MiniModal.SELECTOR_CLASS_CONTENT )

		this.trapFocusHandler = null
		this.clickMapping()
	}

	clickMapping() {
		this.trigger.addEventListener( 'click', () => {
			const isActive = this.trigger.classList.contains( MiniModal.CLASS_NAME_ACTIVE )

			if ( isActive ) {
				this.modalContent.classList.remove( MiniModal.CLASS_NAME_ACTIVE )
				this.trigger.classList.remove( MiniModal.CLASS_NAME_ACTIVE )
				this.releaseFocus()
			} else {
				this.modalContent.classList.add( MiniModal.CLASS_NAME_ACTIVE )
				this.trigger.classList.add( MiniModal.CLASS_NAME_ACTIVE )
				this.modalContent.focus()
				this.trapFocus()
			}
		} )

		this.close.addEventListener( 'click', () => {
			this.modalContent.classList.remove( MiniModal.CLASS_NAME_ACTIVE )
			this.trigger.classList.remove( MiniModal.CLASS_NAME_ACTIVE )
			this.trigger.focus()
			this.releaseFocus()
		} )

		this.modalContent.addEventListener( 'keydown', ( e ) => {
			if ( e.key === MiniModal.KEYCODE_ESCAPE ) {
				this.modalContent.classList.remove( MiniModal.CLASS_NAME_ACTIVE )
				this.trigger.classList.remove( MiniModal.CLASS_NAME_ACTIVE )
				this.trigger.focus()
				this.releaseFocus()
			}
		} )
	}

	trapFocus() {
		const focusableSelector = `a, button, input, textarea, select, [${ MiniModal.ATTR_TABINDEX }]:not([${ MiniModal.ATTR_TABINDEX }="-1"])`
		const focusableElements = Array.from( this.modalContent.querySelectorAll( focusableSelector ) )
		const firstElement = focusableElements[ 0 ]
		const lastElement = focusableElements[ focusableElements.length - 1 ]

		this.trapFocusHandler = ( e ) => {
			if ( e.key === MiniModal.KEYCODE_TAB ) {
				if ( e.shiftKey ) {
					if ( document.activeElement === firstElement ) {
						e.preventDefault()
						lastElement.focus()
					}
				} else {
					if ( document.activeElement === lastElement ) {
						e.preventDefault()
						firstElement.focus()
					}
				}
			}
		}

		this.modalContent.addEventListener( 'keydown', this.trapFocusHandler )
	}

	releaseFocus() {
		if ( this.trapFocusHandler ) {
			this.modalContent.removeEventListener( 'keydown', this.trapFocusHandler )
			this.trapFocusHandler = null
		}
	}
}

export default function init() {
	const modals = document.querySelectorAll( MiniModal.SELECTOR_CLASS_MINIMODAL )
	modals.forEach( ( modal ) => {
		new MiniModal( modal )
	} )
}